import * as React from "react";
import { Button, Grid, Icon } from "semantic-ui-react";
import { sortBy } from "lodash";

import { CurrentUser } from "../../../../auth";

import { Customer } from "../../../customer";
import { WarningIndicator } from "../../../employeeRecord/components/details/WarningIndicator";

import { PartialOhCaseDetailModel } from "../../model";

import { EmployeeRecordDetails } from "./EmployeeRecordDetails";
import { TotallyConfidentialSection } from "./TotallyConfidentialSection";
import { HealthSurveillanceCaseInfo } from "./healthSurveillanceCase/HealthSurveillanceCaseInfo";

export interface CoreDetailsInfoProps {
    customerId: string;
    customer: Customer;
    ohCase?: PartialOhCaseDetailModel;
    refreshCase: (ohCaseId: string, customerId: string) => void;
    currentUser: CurrentUser;
}

export const CoreDetailsInfo = ({ customerId, customer, ohCase, refreshCase, currentUser }: CoreDetailsInfoProps) => {
    return (
        <Grid.Row>
            <Grid.Column width={8}>
                <h1>
                    <EmployeeRecordDetails customer={customer} employeeRecordId={ohCase?.employeeRecordId} />
                    {`${ohCase?.employeeFirstName} ${ohCase?.employeeLastName}`}
                    <WarningIndicator
                        notes={ohCase?.criticalNotes}
                        purchaseOrderNumber={ohCase?.purchaseOrderNumber}
                        purchaseOrderRequiredPerCase={customer?.purchaseOrderRequiredPerCase}
                    />
                </h1>
                <h3>{ohCase?.personalEmailAddress}</h3>
                {ohCase &&
                    <Button icon onClick={() => refreshCase(ohCase.id, customerId)}>
                        <Icon name='refresh' />
                    </Button>
                }
            </Grid.Column>
            <Grid.Column width={8}>
                <h1>{ohCase?.caseType?.toLocaleUpperCase()} CASE{ohCase?.isSelfReferral && " (Self)"}</h1>
                <TotallyConfidentialSection currentUser={currentUser} ohCase={ohCase} customerId={customerId} />
                <HealthSurveillanceCaseInfo ohCase={ohCase} />
                {ohCase?.immunisations &&
                    <div>{sortBy(ohCase.immunisations, [imm => imm.name.toLowerCase()], "name").map(i => i.name).join(", ")}</div>
                }
                <h3>{ohCase?.origin ?? ""}</h3>
                <h3>{ohCase?.secondaryCaseStatus ?? ""}</h3>
            </Grid.Column>
        </Grid.Row>
    );
};
